import { render } from "./express.vue?vue&type=template&id=8ff76c00&scoped=true"
import script from "./express.vue?vue&type=script&lang=js"
export * from "./express.vue?vue&type=script&lang=js"

import "./express.vue?vue&type=style&index=0&id=8ff76c00&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ff76c00"],['__file',"src/views/order/products/express.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8ff76c00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8ff76c00', __exports__)) {
    console.log('reload')
    api.reload('8ff76c00', __exports__)
  }
  
  module.hot.accept("./express.vue?vue&type=template&id=8ff76c00&scoped=true", () => {
    console.log('re-render')
    api.rerender('8ff76c00', render)
  })

}


export default __exports__